angular
  .module('contrast.factory.score', [])
  .factory('ScoreFactory', function ($http, UserService) {
    return {
      getScores: function () {
        return $http.get(UserService.buildAPIUrl('/scores'))
      },
      getDefenseScores: function () {
        return $http.get(UserService.buildAPIUrl('/scores/defense'))
      },

      //score trend
      getScoreTrend: function () {
        return $http.get(UserService.buildAPIUrl('/history/scores'))
      },

      //breakdown
      getTraceBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/trace'))
      },
      getTraceBreakdownBySeverity: function () {
        return $http.get(
          UserService.buildAPIUrl('/scores/breakdown/trace/severity')
        )
      },
      getTraceBreakdownByStatus: function () {
        return $http.get(
          UserService.buildAPIUrl('/scores/breakdown/trace/status')
        )
      },
      getTraceBreakdownByRule: function () {
        return $http.get(
          UserService.buildAPIUrl('/scores/breakdown/trace/rule')
        )
      },
      getRuleBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/rule'))
      },
      getCategoryBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/category'))
      },
      getSeverityBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/severity'))
      },
      getTraceStatusBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/status'))
      },
      getServerTypeBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/scores/breakdown/server'))
      },

      filterByGrade: function (expandValue, grade, includeMerged) {
        return $http.get(UserService.buildAPIUrl('/scores/grade/filter'), {
          params: {
            expand: expandValue,
            grade: grade,
            includeMerged: includeMerged
          }
        })
      },

      getAttackBreakdownByStatus: function (environment) {
        return environment
          ? $http.get(
              UserService.buildAPIUrl('/scores/breakdown/attack/status'),
              { params: { environment: environment } }
            )
          : $http.get(
              UserService.buildAPIUrl('/scores/breakdown/attack/status')
            )
      },
      getAttackBreakdownByType: function (environment) {
        return environment
          ? $http.get(
              UserService.buildAPIUrl('/scores/breakdown/attack/type'),
              { params: { environment: environment } }
            )
          : $http.get(UserService.buildAPIUrl('/scores/breakdown/attack/type'))
      }
    }
  })
